import React from 'react';
import { Link } from 'react-router-dom';
import { getPosts } from '../../services/blogService';

const Blog = () => {
    const posts = getPosts();

    const formatDate = (dateString) => {
        const options = { month: 'short', day: 'numeric', year: 'numeric' };
        const formattedDate = new Intl.DateTimeFormat('en-US', options).format(new Date(dateString));
        return `${formattedDate}`;
    };

    return (
        <div style={{ padding: '24px', maxWidth: '660px', margin: '0 auto' }}>
            <h2 style={{ textAlign: 'center', marginBottom: '32px', fontSize: '2.0rem', color: '#333', fontWeight: '500' }}>Instapath Blog</h2>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0px' }}>
                {posts.map((post, index) => (
                    <React.Fragment key={post.slug}>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                gap: '16px',
                                padding: '8px 0',
                            }}
                        >
                            <div style={{ flex: 1 }}>
                                <Link to={`/blog/${post.slug}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                                    <h2
                                        style={{
                                            fontSize: '1.25rem',
                                            margin: '0 0 8px',
                                            color: '#222',
                                            fontWeight: '500',
                                            transition: 'color 0.3s',
                                        }}
                                        onMouseEnter={(e) => (e.target.style.color = '#3498db')}
                                        onMouseLeave={(e) => (e.target.style.color = '#222')}
                                    >
                                        {post.title}
                                    </h2>
                                </Link>
                                <p style={{ margin: '0 0 8px', color: '#555', fontSize: '0.9rem' }}>
                                    {post.description}
                                </p>
                                <small style={{ color: '#888', fontSize: '0.75rem' }}>
                                    {formatDate(post.date)} • {post.author}
                                </small>
                            </div>
                            <div style={{ flexShrink: 0, width: '200px', height: '130px', overflow: 'hidden' }}>
                                <img
                                    src={post.image || 'https://instapath.io/images/logo_512x512.png'}
                                    alt={post.title}
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover',
                                        borderRadius: '8px',
                                        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                    }}
                                    loading="lazy"
                                />
                            </div>
                        </div>
                        {index < posts.length - 1 && <hr style={{ border: 'none', borderTop: '1px solid #e0e0e0' }} />}
                    </React.Fragment>
                ))}
            </div>
        </div>
    );
};

export default Blog;